//공통 입력창 (이름, 학번, 등 입력용)
import React from "react";
import './FormInput.css'

function FormInput({type='text',name,value,onChange,placeholder,className=""}){
    return(
        <div>
            <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`common-form-input ${className}`}
            ></input>
        </div>
    )
}
 export default FormInput
